import { bisector } from 'd3-array';
import { format } from 'date-fns';
import type {
  DivPaymentDetailRawData,
  DividendData,
  NullableDividendData,
} from '../StabilityAndGrowthOfPayments/hooks/types';
import { getValidDividends } from '../StabilityAndGrowthOfPayments/containers/utils';

const getTodayDate = () => format(new Date(), 'yyyy-MM-dd');

export const pickDividendData = (
  dividendData: DivPaymentDetailRawData,
  endDate?: string
) => {
  const bisect = bisector((d: NullableDividendData) => new Date(d.exDate ?? 0));
  const normalizedEndDate = endDate || getTodayDate();

  const dividends = getValidDividends(dividendData);

  const sortedDividends = dividends.sort((a, b) => {
    const dateA = new Date(a.exDate).getTime();
    const dateB = new Date(b.exDate).getTime();
    return dateA - dateB;
  });

  const index =
    bisect.left(
      sortedDividends,
      new Date(normalizedEndDate),
      1,
      sortedDividends.length
    ) - 1; // zero-based index

  return sortedDividends[index] || ({} as DividendData);
};
